module.exports = __webpack_public_path__ + "static/media/capitaoRocha.160e8d8a.jpeg";